module.exports = __webpack_public_path__ + "img/banner.368776bc.png";